import { useEffect, useState, forwardRef } from "react";
import Lottie from 'react-lottie';
import * as animationData from './confetti-animation.json';
import styled from "styled-components";
import MuiBlock from "../MuiCustoms";
import { Dialog, DialogContent, Fade, Button } from "@mui/material";

const Container = styled(MuiBlock)`
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1299;
    background-color: rgba(255,255,255,0);
    transition: 1s ease;
    
    &.isActive {
        background-color: rgba(255,255,255,.8);
    }
`;

const CustomDialogContent = styled(DialogContent)`
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    gap: 1.5rem;
    min-width: 20vw;
    min-height: 20vw;

    & > span {
        font-size: 5rem;
    }

    & > div {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-items: center;

        & > p {
            margin: 0;
        }

        & > strong {
            display: block;
            font-size: var(--font-size-xxl);
            line-height: 1.1em;
        }
    }
`

const LuckyNumberConfetti = ({promoId, show}) => {
    const storageCurrentKey = 'luckyNumberWinner';
    const [openedModal, setOpenedModal] = useState(false);
    const [showConfetti, setShowConfetti] = useState(false);
    const lottieWidth = window.innerWidth;
    const lottieHeight = window.innerHeight;
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    const DialogTransition = forwardRef(function Transition(props, ref) {
      return <Fade ref={ref} {...props} />;
    });

    useEffect(() => {
        let currentStorageWinners = sessionStorage.getItem(storageCurrentKey) === null ? '' : sessionStorage.getItem(storageCurrentKey);
        if(showConfetti) {
            sessionStorage.setItem(storageCurrentKey,`${currentStorageWinners}${promoId},`);
        } 
    },[showConfetti])

    useEffect(() => {
        let currentStorageWinners = sessionStorage.getItem(storageCurrentKey) === null ? '' : sessionStorage.getItem(storageCurrentKey);
        console.log('showConfetti', show, currentStorageWinners);
        console.log(sessionStorage);
        if(show && currentStorageWinners.indexOf(promoId) === -1) {
            setShowConfetti(true);
        }

        setTimeout(() => {
            setOpenedModal(true);
        },400);
    },[]);

    return showConfetti && (
        <Container className={openedModal ? 'isActive' : ''}>
            <Lottie options={defaultOptions} width={lottieWidth} height={lottieHeight} />
            <Dialog
                open={openedModal}
                onClose={() => setShowConfetti(false)}
                TransitionComponent={DialogTransition}
                keepMounted
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: 'transparent'
                        }
                    }
                }}
                PaperProps={{
                    style: {
                        zIndex: '1302',
                        borderRadius: '1rem',
                        boxShadow: '0px 0px 12px 0 rgba(0,0,0,0.1)'
                    }
                }}
            >
                <CustomDialogContent>
                    <span>🎉</span>
                    <div>
                        <strong>Você tem um<br/> número sorteado!</strong>
                        <p>Em breve entraremos em contato.</p>
                        <Button onClick={() => setShowConfetti(false)} variant="outlined" className="button small" style={{width: "fit-content", borderRadius: "99px", fontWeight: "bold"}}>Fechar</Button>
                    </div>
                </CustomDialogContent>
            </Dialog>
        </Container>
    )
}

export default LuckyNumberConfetti;